export default {
  confirmationModal: {
    title: 'Good news!',
    message: 'Your assessment was submitted successfully.',
    labels: {
      submit: 'Go home'
    }
  }
};